import { openRouterCatalogueSchema } from '@acasa/shared'
import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/lib/api'

/**
 * OpenRouter's model catalogue, for the briefing model picker.
 *
 * Every fetch is a call to OpenRouter (the server caches, but a miss goes
 * out), so the query is gated — admins only, and only while the draft names
 * OpenRouter — kept for an hour, never retried and never refetched on focus.
 * A failure is not fatal: the picker falls back to the curated suggestions and
 * offers "Erneut versuchen".
 */
export function useBriefingModels(enabled: boolean) {
  return useQuery({
    queryKey: ['briefing-models'],
    queryFn: () => apiFetch('/settings/briefing-models', openRouterCatalogueSchema),
    enabled,
    staleTime: 60 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
    // After a failure only "Erneut versuchen" asks again — a provider toggle
    // or a remount must not fire another failing call to OpenRouter.
    refetchOnMount: false,
    retryOnMount: false,
  })
}
